<!--教室信息新增/编辑页面-->
<template>
  <!--<el-card shadow="never"-->
           <!--class="">-->
  <div class="pkg-search-box">
    <!-- 创建培训教室 -->
    <!--<h3>{{ $t('res.cri.createTrainRoom') }}</h3>-->
    <el-form class="pkg-content" :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             :inline="false">
      <el-row class="location-layout">
        <el-col :span="1">
          <!-- ID -->
          <el-form-item :label="$t('res.cri.classroomNo')"
                        v-show="false"
                        prop="id">
            <el-input v-model="dataForm.id"
                      :disabled="true"
                      v-show="false"
                      :placeholder="$t('res.cri.sysAutoCreate')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 教室编号 -->
          <el-form-item :label="$t('res.cri.classroomNo')"
                        prop="classroomNo">
            <el-input v-model="dataForm.classroomNo"
                      :disabled="true"
                      :placeholder="$t('res.cri.sysAutoCreate')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 教室中文名称 -->
          <el-form-item :label="$t('res.cri.roomCnName')"
                        prop="roomCnName">
            <el-input v-model.trim="dataForm.roomCnName"
                      maxlength="255"
                      :placeholder="$t('res.cri.inputRoomCnName')"></el-input>
          </el-form-item>
        </el-col>
        <!--<el-col :span="8">-->
        <!--&lt;!&ndash; 教室英文名称 &ndash;&gt;-->
        <!--<el-form-item :label="$t('res.cri.roomEnName')"-->
        <!--prop="roomEnName">-->
        <!--<el-input v-model.trim="dataForm.roomEnName"-->
        <!--maxlength="255"-->
        <!--:placeholder="$t('res.cri.roomEnName')"></el-input>-->
        <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="8">
          <!-- 教室中文简称 -->
          <el-form-item :label="$t('res.cri.roomCnAbbr')"
                        prop="roomCnAbbr">
            <el-input v-model.trim="dataForm.roomCnAbbr"
                      maxlength="255"
                      :placeholder="$t('res.cri.inputRoomCnAbbr')"></el-input>
          </el-form-item>
        </el-col>
        <!--<el-col :span="8">-->
        <!--&lt;!&ndash; 教室英文简称 &ndash;&gt;-->
        <!--<el-form-item :label="$t('res.cri.roomEnAbbr')"-->
        <!--prop="roomEnAbbr">-->
        <!--<el-input v-model.trim="dataForm.roomEnAbbr"-->
        <!--maxlength="255"-->
        <!--:placeholder="$t('res.cri.roomEnAbbr')"></el-input>-->
        <!--</el-form-item>-->
        <!--</el-col>-->
      </el-row>
        <br/>
      <el-row>
        <el-col :span="8">
          <!-- 所属场地 -->
          <el-form-item :label="$t('res.cri.subordinateSite')"
                        prop="subordinateSite">
            <el-input v-model="dataForm.subordinateSite"
                      @focus="showSuboSiteDlg()"
                      :disabled="type === 'update'"
                      readonly
                      :placeholder="$t('res.vehinfo.select')"></el-input>
            <el-input v-model="dataForm.siteId"
                      v-show="false"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 教室分类 -->
          <el-form-item :label="$t('res.cri.classroomClass')"
                        prop="classroomClassId">
            <class-tree ref="classRef"
                        v-on:getSelectList="getSelectList"
                        v-bind:defaultProps="defaultProps"
                        v-bind:url="queryTreeUrl"
                        v-bind:showArray="dataForm.showSiteClassList"
                        v-bind:showValue="dataForm.showValue"
                        v-on:clearTreeInfo="clearClassRoomTree"
                        v-bind:isSelect=true
                        v-bind:filterText="'10'"
                        v-bind:status="'roomClassStatus'"></class-tree>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 是否统计 -->
          <el-form-item :label="$t('res.cri.ifCount')"
                        prop="ifCount">
            <el-select v-model="dataForm.ifCount"
                       :placeholder="$t('res.cri.ifCount')">
              <el-option v-for="(item,index) in ifCountList"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="8">
          <!-- 开始日期 -->
          <!--:disabled="type === 'update'"-->
          <el-form-item :label="$t('res.cri.startTime')"
                        prop="startTime">
            <el-date-picker v-model="dataForm.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('res.cri.startTime')">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 结束日期 -->
          <!--:picker-options="checkEndTime"-->
          <el-form-item :label="$t('res.cri.endTime')"
                        prop="endTime">
            <el-date-picker v-model="dataForm.endTime"
                            :disabled="dataForm.status === '20'"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('res.cri.inputEndTime')">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 教室状态 -->
          <el-form-item :label="$t('res.cri.status')"
                        prop="status">
            <el-select v-model="dataForm.status"
                       :disabled="true"
                       :placeholder="$t('res.cri.status')">
              <el-option v-for="(item,index) in statusList"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="8">
          <!-- 租用费用 -->
          <el-form-item prop="rentalFee">
            <span slot="label">{{$t('res.cri.rentalFee')}}</span>
            <el-input v-model.trim="dataForm.rentalFee"
                      :placeholder="$t('res.cri.inputRentalFee')"
                      maxlength="8"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 管理费用 -->
          <el-form-item prop="managementFee">
            <span slot="label">{{$t('res.cri.managementFee')}}</span>
            <el-input v-model.trim="dataForm.managementFee"
                      :placeholder="$t('res.cri.inputManagementFee')"
                      maxlength="8"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 餐饮费用 -->
          <el-form-item :label="$t('res.cri.cateringExpenses')"
                        prop="cateringExpenses">
            <el-input v-model.trim="dataForm.cateringExpenses"
                      :disabled="true"
                      :placeholder="$t('res.cri.inputCateringExpenses')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="8">
          <!-- 面积M2 -->
          <el-form-item prop="roomArea">
            <span slot='label'>{{ $t('res.cri.roomArea') }}(M<sup>2</sup>)</span>
            <el-input v-model.trim="dataForm.roomArea"
                      :placeholder="$t('res.cri.inputRoomArea')"
                      maxlength="8"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 楼层 -->
          <el-form-item :label="$t('res.cri.floor')"
                        prop="floor">
            <el-input v-model.number.trim="dataForm.floor"
                      :placeholder="$t('res.cri.inputFloor')"
                      maxlength="8"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 举升机数量 -->
          <el-form-item :label="$t('res.cri.liftNo')"
                        prop="liftNo">
            <el-input v-model.number.trim="dataForm.liftNo"
                      :placeholder="$t('res.cri.inputLiftNo')"
                      maxlength="8"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="8">
          <!-- 工位数量 -->
          <el-form-item :label="$t('res.cri.workplaceNo')"
                        prop="workplaceNo">
            <el-input v-model.number.trim="dataForm.workplaceNo"
                      :placeholder="$t('res.cri.inputWorkplaceNo')"
                      maxlength="8"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 最大人数 -->
          <el-form-item :label="$t('res.cri.maxNo')"
                        v-if="!isSteNo"
                        prop="maxNo">
            <el-input v-model.number.trim="dataForm.maxNo"
                      :placeholder="$t('res.cri.inputMaxNo')"
                      maxlength="8"></el-input>
          </el-form-item>
          <el-form-item :label="$t('res.cri.maxNo')"
                        v-if="isSteNo"
                        :rules="{ required: true, trigger: 'change', message: '最大人数不能为空' }"
                        prop="maxNo">
            <el-select v-model="dataForm.maxNo"
                       :placeholder="$t('res.cri.maxNo')">
              <el-option v-for="(item,index) in maxNoList"
                         :key="index"
                         :label="item.code"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <br/>
      <el-row :gutter="0">
        <!--上传教室布局文件-->
        <el-col :span="7">
          <el-form-item prop="isUpload">
            <upload-file v-bind:fileList="fileList"
                         v-bind:beforeRemove="uploadBeforeRemove"
                         v-bind:uploadSuccess="submitUploadSuccess"></upload-file>
          </el-form-item>
          <div style="text-align: left;font-size: 12px;color: darkgray;">{{'上传教室布局信息文件(不超过4M，上传格式为jpg/png/xlsx/xls/zip/rar/txt/pdf文件)'}}</div>
          <el-button v-if="dataForm.fileName !== '' || dataForm.fileName"
                     size="mini"
                     @click="downloadFile"
                     type="text">{{dataForm.fileName}}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <br>
    <div class="pkg-content">
      <h3>{{ $t('res.cri.tag') }}</h3>
      <el-form label-position="top"
               label-width="145px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "true"
                     :closeShow = "true"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <br>
    <div class="pkg-content">
      <el-row>
        <el-col :span="24"
                style="line-height: 34px;">
          <div>
            <div class="label-title">{{ $t('res.cri.yearTargetList') }}</div>
            <div class="button-icon">
            <!-- 新增 -->
              <el-button type="primary"
                     @click="addTarget()">{{ $t('add') }}</el-button>
              <div class="el-icon-arrow-up pkg-icon-button"
                   v-if="isShowYearTarget"
                   @click="isShowYearTarget = !isShowYearTarget"></div>
              <div class="el-icon-arrow-down pkg-icon-button"
                   v-else
                   @click="isShowYearTarget = !isShowYearTarget"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <br>
      <el-row v-show="isShowYearTarget">
      <el-col :span="24">
        <el-table :data="targetTableData"
                  height="250"
                  border
                  style="width: 100%">
          <!-- 年份 -->
          <el-table-column prop="annual"
                           align="center"
                           :label="$t('res.cri.year')"
                           min-width="180">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit || scope.row.isAdd"
                        size="mini"
                        v-model="scope.row.annual"
                        maxlength="4"></el-input>
              <span v-else>{{scope.row.annual}}</span>
            </template>
          </el-table-column>
          <!-- 报表年度目标 -->
          <el-table-column prop="reportAnnualTarget"
                           align="center"
                           :label="$t('res.cri.yearTarget')"
                           min-width="180">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit || scope.row.isAdd"
                        size="mini"
                        v-model="scope.row.reportAnnualTarget"
                        maxlength="10"></el-input>
              <span v-else>{{scope.row.reportAnnualTarget}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column prop="operation"
                           align="center"
                           :label="$t('res.cri.operation')"
                           width="250">
            <template slot-scope="scope">
              <!--修改按钮-->
              <el-button type="primary"
                         v-if="scope.row.isEdit || ((new Date(String(new Date().getFullYear())).getTime() <= new Date(scope.row.annual).getTime()) && !scope.row.isAdd)"
                         size="mini"
                         @click="editTarget(scope.row, scope.$index)">{{ $t('res.cri.edit') }}</el-button>
              <template v-if="isAddForm">
                <!-- 清除（配合新增使用） -->
                <el-button type="primary"
                           v-if="scope.row.isAdd"
                           @click="deleteTarget(scope.$index)">{{ $t('delete') }}</el-button>
              </template>
              <!--删除按钮（配合编辑使用）-->
              <el-button type="primary"
                         v-if="scope.row.isEdit || ((new Date(String(new Date().getFullYear())).getTime() <= new Date(scope.row.annual).getTime()) && !scope.row.isAdd)"
                         size="mini"
                         @click="targetDelete(scope.$index)">{{ $t('delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    </div>
    <br>
    <!-- 保存按钮 -->
    <div class="pkg-content">
      <div class="btn-position-up"
           style="text-align:right;">
        <el-button :loading="dataListLoading"
                   type="primary"
                   @click.native="dataFormSubmitHandle()">{{ $t('res.cri.save') }}
        </el-button>
        <el-button type="info"
                   @click="backPage()">{{ $t('res.vehinfo.back') }}</el-button>
      </div>
    </div>
    <!-- 所属场地-->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='true'
                      :isShow='false'
                      :isQueryShow="true"
                      v-bind:selectTable="selectTable"
                      v-bind:statusList="queryStatusList"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack"></subordinate-site>
  </div>
</template>

<script>
import subordinateSite from '@/components/rm/resources-site/index'
import classroomClass from '@/components/rm/classroom-class/index'
import { getUUID } from '@/utils/index'
import ClassTree from '@/components/rm/class-tree/index'
import UploadFile from '@/components/rm/upload-file/index'
import Tag from '@/components/rm/label/index'
import VueI18n from '@/i18n'
export default {
  components: {
    Tag,
    'subordinate-site': subordinateSite,
    'classroom-class': classroomClass,
    'class-tree': ClassTree,
    'upload-file': UploadFile
  },
  data () {
    let _this = this
    //
    var integerVali = (rule, value, callback) => {
      if (!value) {
        return callback()
      }
      let reg = /^\d+$/
      if (!reg.test(value)) {
        callback(new Error(_this.$t('res.cri.r.nonnegativeInteger')))
      } else {
        callback()
      }
    }
    // 租用费用，管理费用校验---只能为正数
    var decimalVali = (rule, value, callback) => {
      if (!value) {
        return callback()
      }
      let reg = /^\d+(\.\d+)?$/
      if (!reg.test(value)) {
        callback(new Error(this.$t('res.cri.r.nonnegativeFloat')))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      dataForm: {
        id: 0,
        classroomNo: '',
        roomCnName: '',
        // roomEnName: '',
        roomCnAbbr: '',
        // roomEnAbbr: '',
        classroomClassId: '',
        siteId: '',
        // 所属场地显示值
        subordinateSite: '',
        status: '10',
        startTime: new Date(),
        labelId:'',
        endTime: '',
        rentalFee: '',
        managementFee: '',
        cateringExpenses: '0',
        ifCount: '10',
        floor: '',
        roomArea: '',
        maxNo: '',
        version: '',
        // 举升机数量
        liftNo: '',
        // 工位数量
        workplaceNo: '',
        showValue: '',
        showSiteClassList: [],
        // 年度目标列表数据
        targetTableData: [],
        isUpload: '',
        // 文件上传信息
        fileUpload: undefined,
        // 文件名称
        fileName: '',
        // 文件id
        fileId: ''
      },
      dataRule: {
        roomCnName: [
          { required: true, message: this.$t('res.cri.r.roomCnName'), trigger: 'blur' }
        ],
        // roomEnName: [
        //   { required: true, message: this.$t('res.cri.r.roomEnName'), trigger: 'blur' }
        // ],
        roomCnAbbr: [
          { required: true, message: this.$t('res.cri.r.roomCnAbbr'), trigger: 'blur' }
        ],
        // roomEnAbbr: [
        //   { required: true, message: this.$t('res.cri.r.roomEnAbbr'), trigger: 'blur' }
        // ],
        classroomClassId: [
          { required: true, message: this.$t('res.cri.r.classroomClass'), trigger: 'change' }
        ],
        subordinateSite: [
          { required: true, message: this.$t('res.cri.r.siteId'), trigger: 'change' }
        ],
        status: [
          { required: true, message: this.$t('res.cri.r.status'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('res.cri.r.startTime'), trigger: 'blur' }
        ],
        ifCount: [
          { required: true, message: this.$t('res.cri.r.ifCount'), trigger: 'blur' }
        ],
        floor: [
          { validator: integerVali, trigger: 'blur' }
        ],
        liftNo: [
          { validator: integerVali, trigger: 'blur' }
        ],
        workplaceNo: [
          { validator: integerVali, trigger: 'blur' }
        ],
        maxNo: [
          { validator: integerVali, trigger: 'blur' }
        ],
        // 租用费用
        rentalFee: [
          { validator: decimalVali, trigger: 'blur' }
        ],
        // 管理费用
        managementFee: [
          { validator: decimalVali, trigger: 'blur' }
        ],
        // 面积
        roomArea: [
          { validator: decimalVali, trigger: 'blur' }
        ]
      },
      queryStatusList:['10'],
      isEditTableObj: {},
      // 是否统计下拉列表
      ifCountList: this.enums['confirmState'],
      // 教室状态下拉列表
      statusList: this.enums['status'],
      // 最大人数
      maxNoList: this.enums['tencentMeetingVolume'],
      // 标签数据
      tagTableData: [{
        tagType: '车辆',
        tagContent: '汽车发动机'
      }, {
        tagType: '车辆',
        tagContent: '汽车变速箱'
      }, {
        tagType: '车辆',
        tagContent: 'cess'
      }],
      targetTableData: [],
      // 是否显示所属场地
      isShowSuboSite: false,
      dataListLoading: false,
      // 教室分类类型
      classroomClassType: '',
      //  所属场地分类(保存时做校验使用)
      siteType: '',
      //  教室分类(保存时做校验使用)
      classroomType: '',
      // 校验结束时间
      checkEndTime: this.checkSiteInfoEndTime(),
      checkList: [],
      checkeList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: [],
      bussinessTypeChecked: [],
      /// / 操作类型 新增/修改
      type: '',
      // 上传的文件
      fileList: [],
      // 教室分类ID
      classroomClassId: '',
      classroomClassValue: '',
      showSiteClassList: [],
      // 场地分类
      defaultProps: {
        children: 'children',
        label: 'roomClassCnName'
      },
      queryTreeUrl: '/rm/classroomclass/list',
      isAddForm: false,
      selectTable: [],
      // 是否显示年度目标
      isShowYearTarget: true,
      siteNo: ''
    }
  },
  computed: {
    isSteNo() {
      console.log('--------------------', this.siteNo)
      if(this.siteNo === 'CD100117') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.initMethod()
    this.$eventHub.$on(this.GLOBAL.CLASSROOM_INFO, (data) => {
      this.siteNo = ''
      this.initMethod()
    })
  },
  methods: {
    clearClassRoomTree (){
      this.dataForm.classroomClassId = ''
    },
    // 页面打开初始化方法
    initMethod () {
    
      // 清空教室分类树
      this.$refs.classRef && this.$refs.classRef.resetChecked()
      this.$nextTick(() => {
        // 将表单初始值并移除校验结果
        this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      })
      // 清空年度目标table
      this.targetTableData = []
      // 清空文件上传信息
      this.fileList = []
      this.dataForm.fileUpload = undefined
      this.dataForm.fileName = ''
      this.dataForm.fileId = ''
      this.dataForm.id = ''
      this.dataForm.labelId = ''
      this.checkList = []
      this.$nextTick(() => {
        // 操作类型赋值
        this.type = this.$route.query.type
        if (this.$route.query.siteClassType && this.$route.query.siteClassType !== '') {
          this.siteType = this.$route.query.siteClassType
        }
        if (this.$route.query.siteId && this.$route.query.siteId !== '') {
          this.dataForm.siteId = this.$route.query.siteId
        }
        if (this.$route.query.siteCnName && this.$route.query.siteCnName !== '') {
          this.dataForm.subordinateSite = this.$route.query.siteCnName
        }
        if (this.$route.query.cateringExpenses && this.$route.query.cateringExpenses !== '') {
          this.dataForm.cateringExpenses = this.$route.query.cateringExpenses
        }
        if (this.$route.query.id !== undefined) {
          this.dataForm.id = this.$route.query.id
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$request.get(`/rm/classroominfo/editor/${this.dataForm.id}`).then((data) => {
        console.info('data------------------>', data)
        this.classroomClassType = data.classroomClassType
        this.classroomClassId = data.classroomClassId
        this.classroomClassValue = data.roomClassCnName
        this.showSiteClassList.push(data.classroomClassId)
        this.dataForm.id = data.id
        this.dataForm.classroomNo = data.classroomNo
        this.dataForm.roomCnName = data.roomCnName
        // this.dataForm.roomEnName = data.roomEnName
        this.dataForm.roomCnAbbr = data.roomCnAbbr
        // this.dataForm.roomEnAbbr = data.roomEnAbbr
        this.dataForm.subordinateSite = data.siteCnName
        this.dataForm.startTime = data.startTime
        this.dataForm.endTime = data.endTime
        this.dataForm.status = data.status
        this.dataForm.rentalFee = data.rentalFee
        this.dataForm.managementFee = data.managementFee
        this.dataForm.cateringExpenses = data.cateringExpenses
        this.dataForm.ifCount = data.ifCount
        this.dataForm.roomArea = data.roomArea
        this.dataForm.floor = data.floor
        this.dataForm.liftNo = data.liftNo
        this.dataForm.workplaceNo = data.workplaceNo
        this.dataForm.maxNo = data.maxNo
        this.dataForm.siteId = data.siteId
        // this.siteNo = data.siteNo
        this.dataForm.classroomClassId = data.classroomClassId
        this.dataForm.showValue = data.roomClassCnName
        this.dataForm.showSiteClassList = []
        this.dataForm.showSiteClassList.push(data.classroomClassId)
        this.bussinessTypeId = data.bussinessTypeId
        this.bussinessTypeChecked = data.bussinessTypeId
        this.dataForm.isUpload = data.isUpload
        this.targetTableData = data.targetTableData
        this.dataForm.fileName = data.fileName
        this.dataForm.fileId = data.fileId
        this.$request.get(`/rm/siteinfo/listNoAuth?page=1&limit=10&siteNo=CD100117`).then((res) => {
          console.log(res)
          let resData = res.records[0]
          if (resData.id === this.dataForm.siteId) {
            this.siteNo = resData.siteNo
          }
        })
        // 已选择的标签
        this.checkList = data.commLabelVoList ? data.commLabelVoList : []
        this.checkeList = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameCn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameCn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameEn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameEn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        }
      })
    },
    // 年度目标校验正整数的正则表达式
    isPositiveInteger (s) {
      let re = /^\+?[0-9][0-9]*$/
      return re.test(s)
    },
    // 表单提交
    dataFormSubmitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 控制保存按钮，防止重复点击保存
          this.dataListLoading = true
          if(this.dataForm.endTime === ''){
            this.dataForm.endTime = ''
          }
          // else{
          //   if(this.dataForm.startTime > this.dataForm.endTime){
          //     this.$message.warning(this.$t('res.cri.r.checkSiteInfoEndTime'))
          //     this.dataListLoading = false
          //     return false
          //   }
          // }
          // 提示所属场地类型必须与教室分类类型保持一致（只在新增时判断）
          if (this.type === 'add') {
            if (String(this.classroomType) !== String(this.siteType)) {
              this.$message.warning(this.$t('res.cri.site.siteClassroomType'))
              this.dataListLoading = false
              return false
            }
          }
          let url = ''
          let param = ''
          let annualMap = new Map()
          for (let j = 0; j < this.targetTableData.length; j++) {
            let itemJ = this.targetTableData[j]
            //  校验年份是否为空
            if (itemJ.annual === null || itemJ.annual === '') {
              this.$message.warning(this.$t('res.cri.r.annual'))
              this.dataListLoading = false
              return false
            }
            // 校验只能输入当前及以后的年份
            if ((itemJ.isAdd || itemJ.isEdit) && itemJ.annual < new Date().getFullYear()) {
              this.$message.warning(this.$t('res.cri.r.annualCheck'))
              this.dataListLoading = false
              return false
            }
            // 校验年份是否重复
            if (annualMap.get(String(itemJ.annual))) {
              this.dataListLoading = false
              this.$message.warning(this.$t('res.cri.r.yearCheck'))
              return false
            } else {
              annualMap.set(String(itemJ.annual), 'A')
            }
            // 校验年份只能为正整数
            if (!this.isPositiveInteger(itemJ.annual)) {
              this.$message.warning(this.$t('res.cri.r.reportAnnualCheck'))
              this.dataListLoading = false
              return false
            }
            //  校验目标值不能为空
            if (itemJ.reportAnnualTarget === null || itemJ.reportAnnualTarget === '') {
              this.$message.warning(this.$t('res.cri.r.reportAnnualTarget'))
              this.dataListLoading = false
              return false
            }
            // 校验报表年度目标值只能为正整数
            if (!this.isPositiveInteger(itemJ.reportAnnualTarget)) {
              this.$message.warning(this.$t('res.cri.r.reportAnnualTargetCheck'))
              this.dataListLoading = false
              return false
            }
          }
          let bakTargetTableData = [...this.targetTableData]
          for (let i = 0; i < bakTargetTableData.length; i++) {
            let item = bakTargetTableData[i]

            if (String(item.id).indexOf('keyId-') <= 0) {
              item.id = ''
            }
          }
          let tmp = []
          this.dataForm.labelId = ''
          if (this.checkList.length !== 0) {
            this.checkList.forEach(o => {
              tmp.push(o.labelId)
            })
            this.dataForm.labelId = tmp.join(',')
          }
          param = {
            'id': this.dataForm.id,
            'classroomNo': this.dataForm.classroomNo,
            'roomCnName': this.dataForm.roomCnName,
            // 'roomEnName': this.dataForm.roomEnName,
            'roomCnAbbr': this.dataForm.roomCnAbbr,
            // 'roomEnAbbr': this.dataForm.roomEnAbbr,
            'siteId': this.dataForm.siteId,
            'classroomClassId': this.dataForm.classroomClassId,
            'startTime': this.dataForm.startTime,
            'endTime': this.dataForm.endTime,
            'status': this.dataForm.status,
            'rentalFee': this.dataForm.rentalFee,
            'managementFee': this.dataForm.managementFee,
            'cateringExpenses': this.dataForm.cateringExpenses,
            'ifCount': this.dataForm.ifCount,
            'roomArea': this.dataForm.roomArea,
            'floor': this.dataForm.floor,
            'liftNo': this.dataForm.liftNo,
            'workplaceNo': this.dataForm.workplaceNo,
            'maxNo': this.dataForm.maxNo,
            'targetTableData': bakTargetTableData,
            'isUpload': this.dataForm.isUpload,
            'fileUpload': this.dataForm.fileUpload,
            'fileId': this.dataForm.fileId,
            'labelId' : this.dataForm.labelId
          }
          url = `/rm/classroominfo/${!this.dataForm.id ? 'save' : 'update'}`
          this.$request.post(
            url,
            param
          ).then((data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.dataListLoading = false
                if (this.type === 'add' && data) {
                  this.dataForm.id = data.id
                }
                // this.dataForm.id = data.id
                this.type = 'update'
                this.fileList = []
                // 清空表单的校验
                this.$refs['dataForm'] && this.$refs['dataForm'].clearValidate()
                // 保存成功之后关闭页面
                this.tabRemove()
                // 调用页面查询
                // this.getInfo()
              }
            })
          }).catch((error) => {
            this.dataListLoading = false
            console.error(error)
          })
        }
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    backPage () {
      this.$router.go(-1)
    },
    closeSuboSiteDlg () {
      this.isShowSuboSite = false
    },
    showSuboSiteDlg () {
      this.isShowSuboSite = true
      this.$refs.suborSiteRef.initSuborSite()
    },
    //  场地分类带回数据赋值
    bringBack (selection) {
      console.log(selection)
      let rowData = selection[0]
      //  拿到所在场地的类型并赋值，保存时用来与教室分类作比较
      this.siteType = rowData.siteClassType
      this.siteNo = rowData.siteNo
      if (this.siteNo === 'CD100117') {
        this.dataForm.maxNo = ''
      }
      let siteId = rowData.id
      let siteCnName = rowData.siteCnName
      let cateringExpenses = rowData.cateringExpenses
      this.dataForm['siteId'] = siteId
      this.dataForm['cateringExpenses'] = cateringExpenses
      this.dataForm['subordinateSite'] = siteCnName
      this.selectTable = siteId ? [{ id: siteId, siteCnName: siteCnName }] : []
      this.isShowSuboSite = false
    },
    setClassroomClassId (classroomClassId) {
      this.dataForm.classroomClassId = classroomClassId
    },
    //  教室分类
    getSelectList (args) {
      let bussinessTypeIds = []
      if (args && args !== '' && args.length > 0) {
        this.$request.post(
                '/rm/classroomclass/queryClassBrandAndRd', { 'id' : args[0].id ,'levelPid': args[0].levelPid }
        ).then((res) => {
          let vce = res.vce
          // 研发代码
          let rdCode = res.rdCode
          // 品牌
          //let brand = res.brand
          console.info('res------------->', res)
          if(vce.bussinessTypeId){
            bussinessTypeIds.push(vce.bussinessTypeId)
          }
          if(rdCode.bussinessTypeId){
            bussinessTypeIds.push(rdCode.bussinessTypeId)
          }
          //if(brand.bussinessTypeId){
            //bussinessTypeIds.push(brand.bussinessTypeId)
          //}
          this.bussinessTypeId = bussinessTypeIds
          this.bussinessTypeChecked = bussinessTypeIds
        }).catch((error) => {
          this.$message.error(error)
        })
        // let bussinessTypeIds = []
        // if(args[0].bussinessTypeId){
        //   bussinessTypeIds.push(args[0].bussinessTypeId)
        // }
        // this.bussinessTypeId = bussinessTypeIds
        // this.bussinessTypeChecked = bussinessTypeIds
        //  拿到教室分类的类型，保存时与场地分类作比较
        this.classroomType = args[0].classroomClassType
        if (this.type === 'add') {
          this.dataForm.classroomClassId = args[0].id
        }
        if (this.type === 'update') {
          if (String(this.classroomClassType) !== String(args[0].classroomClassType)) {
            this.$message.warning(this.$t('res.cri.site.siteClass'))
            this.$refs.classRef.resetChecked()
            this.dataForm.classroomClassId = this.classroomClassId
            this.$nextTick(() => {
              this.dataForm.showValue = this.classroomClassValue
              this.dataForm.showSiteClassList = JSON.parse(JSON.stringify(this.showSiteClassList))
            })
          } else {
            this.dataForm.classroomClassId = args[0].id
            this.classroomClassValue = args[0].roomClassCnName
            this.showSiteClassList = []
            this.showSiteClassList.push(args[0].id)
          }
        }
      } else {
        this.dataForm.classroomClassId = ''
      }
    },
    // 清除年度目标
    deleteTarget (index) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.targetTableData.splice(index, 1)
      }).catch((err) => {
        console.log(err)
      })
    },

    // 修改年度目标
    editTarget (row, index) {
      this.isAddForm = false
      row['isEdit'] = true
      this.$set(this.targetTableData, index, row)
    },
    // 新增年度目标
    addTarget () {
      this.isAddForm = true
      let year = new Date().getFullYear()
      let uuid = getUUID()
      let target = { 'id': uuid, 'annual': year, 'reportAnnualTarget': '', isAdd: true }
      this.targetTableData.push(target)
    },
    // 删除按钮
    targetDelete (index) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.targetTableData.splice(index, 1)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 校验结束时间
    checkSiteInfoEndTime () {
      return {
        disabledDate: function disabledDate (time) {
          return new Date().getTime() > time.getTime()
        }
      }
    },
    // 获取文件上的后的文件信息
    submitUploadSuccess (response, file, fileList) {
      if (response && response !== '') {
        this.dataForm.fileUpload = response.data
        this.dataForm.fileName = response.data.filename
        this.dataForm.fileId = response.data.fileId
      }
    },
    // 移除文件
    uploadBeforeRemove (file, fileList) {
      this.fileList = []
      this.dataForm.fileUpload = undefined
      this.dataForm.fileName = ''
      this.dataForm.fileId = ''
    },
    // 下载文件
    downloadFile () {
      let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/rm/file/download' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
      let dlform = document.createElement('form')
      dlform.method = 'post'
      dlform.action = requestUrl
      let hdnFilePath = document.createElement('input')
      hdnFilePath.type = 'hidden'
      hdnFilePath.name = 'id'
      hdnFilePath.value = this.dataForm.fileId
      dlform.appendChild(hdnFilePath)
      document.body.appendChild(dlform)
      dlform.submit()
      document.body.removeChild(dlform)
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = []
      this.bussinessTypeId = []
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = []
      // 已选择的标签
      // this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      this.checkList = this.checkeList
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameCn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameCn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameCn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      } else {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameEn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameEn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameEn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      }
    }
  }
}
</script>
<style lang="css" scoped>
  .pkg-search-box {
    color: #303133;
    transition: 0.3s;
    border-radius: 4px;
    overflow: hidden;
  }
  .pkg-content {
    background-color: #fff;
    padding: 20px;
  }
 .label-title {
   font-size: 16px;
   font-weight: bold;
   display: inline-block;
 }
 .button-icon {
   display: inline-block;
   float: right;
 }
</style>